import GestureAbstract from './abstract';

export default class GestureScroll extends GestureAbstract {
  constructor (canvas) {
    super(canvas);
    this.tapDistance = 30;
    this.$el = $('#workarea');
  }

  init (x, y, target, isRightClick, event) {
    INKIVE.GestureAbstract.prototype.init.apply(this, arguments);
    this.hasScrolled = false;

    if (this.canvas.getMode() === 'zooming') {
      const relativeX = x - this.$el[0].getBoundingClientRect().x;
      const widthDifference = this.$el[0].scrollWidth - this.$el.width();
      const xRatio = this.$el.width() / relativeX;
      this.startingX = widthDifference / xRatio;

      const relativeY = y - this.$el[0].getBoundingClientRect().y;
      const heightDifference = this.$el[0].scrollHeight - this.$el.height();
      const yRatio = this.$el.height() / relativeY;
      this.startingY = heightDifference / yRatio;
    } else {
      this.startingX = x;
      this.startingY = y;
    }

    this.startingScrollX = this.$el.scrollLeft();
    this.startingScrollY = this.$el.scrollTop();
  }

  update (x, y, event) {
    if (this.startingX !== null && this.startingY !== null) {
      if (this.canvas.getMode() === 'zooming') {
        this.updateZooming(x, y, event);
        return;
      }

      let diffX = this.startingX - x;
      let diffY = this.startingY - y;

      this.$el
        .scrollTop(this.startingScrollY + diffY)
        .scrollLeft(this.startingScrollX + diffX);

      if (!this.hasScrolled) {
        diffX = Math.abs(this.startingX - x);
        diffY = Math.abs(this.startingY - y);

        this.hasScrolled = diffX + diffY > this.tapDistance;
      }
    }
  }

  updateZooming (x, y, event) {
    if (event?.touches?.length === 1) return;
    const workAreaBBox = this.$el[0].getBoundingClientRect();
    const relativeX = x - workAreaBBox.x;
    const widthDifference = this.$el[0].scrollWidth - workAreaBBox.width;
    const xRatio = workAreaBBox.width / relativeX;
    const currentX = widthDifference / xRatio;
    const diffX = currentX - this.startingX;
    const relativeY = y - workAreaBBox.y;
    const heightDifference = this.$el[0].scrollHeight - workAreaBBox.height;
    const yRatio = workAreaBBox.height / relativeY;
    const currentY = heightDifference / yRatio;
    const diffY = currentY - this.startingY;

    this.$el
      .scrollTop(this.startingScrollY + diffY)
      .scrollLeft(this.startingScrollX + diffX);
  }

  destruct () {
    INKIVE.GestureAbstract.prototype.destruct.call(this);

    this.hasScrolled && this.canvas.clearSelection();

    this.startingX = null;
    this.startingY = null;
  }
}
